import React from 'react';
import classNames from 'classnames';
import CheckboxDescription from './components/checkbox-description';
import CheckboxControl from './components/checkbox-control';
import { APPEARANCES as PARAGRAPH_APPEARANCES } from '../paragraph/constants';
import { SIZES } from './constants';
const Checkbox = ({
  checked = undefined,
  inputRef = undefined,
  indeterminate = false,
  defaultChecked = undefined,
  description = undefined,
  disabled = false,
  id,
  label,
  name = undefined,
  onChange,
  tooltipProps = undefined,
  value,
  isLabelBold = true,
  size = SIZES.medium,
}) => {
  if (checked !== undefined && defaultChecked !== undefined) {
    throw new Error(`
Checkbox component can be either controlled, or uncontrolled.
If you want it to be controlled - please pass the 'checked',
and update it externally via the 'onChange' callback.
If you want it to be uncontrolled - please pass the 'defaultChecked',
and its updates will be handled by the Checkbox component itself.
`);
  }

  const handleChange = (event) => {
    const { checked: isChecked, value: val } = event.target;
    onChange(isChecked, val);
  };

  const classes = classNames('ws-ui-checkbox', `ws-ui-checkbox--${size}`, {
    'ws-ui-checkbox--disabled': disabled,
  });

  return (
    <div className={classes}>
      <CheckboxControl
        checked={checked}
        inputRef={inputRef}
        indeterminate={indeterminate}
        defaultChecked={defaultChecked}
        disabled={disabled}
        id={id}
        name={name}
        onChange={handleChange}
        tooltipProps={tooltipProps}
        value={value}
        isLabelBold={isLabelBold}
      >
        {label}
      </CheckboxControl>
      {description && (
        <CheckboxDescription
          appearance={
            disabled ? PARAGRAPH_APPEARANCES.lowEmphasis : PARAGRAPH_APPEARANCES.mediumEmphasis
          }
        >
          {description}
        </CheckboxDescription>
      )}
    </div>
  );
};

export default Checkbox;
